module.exports = __webpack_public_path__ + "img/大青叶.11c019e5.jpg";